<div class="date-picker-box" [ngClass]="{ 'disabled': IsDisabled }">
    <ion-label class="input-title">{{ViewTitle}}</ion-label>
    <button type="button" class="value-box" [disabled]="IsDisabled" (click)="OnOpenPicker()">
        <span class="value" [ngClass]="{ 'placeholder': !value }">{{value || placeholder}}</span>
        <ion-icon [name]="icon"></ion-icon>
    </button>
</div>
